import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './PREAUCT_Max_Bid_Analysis.css';

const PREAUCT_Max_Bid_Analysis = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"PREAUCT_MAX_BID_ANALYSIS",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	PREAUCT_MAX_BID_ANALYSIS:-1
  });


  const [PREAUCT_MAX_BID_ANALYSIS, setPREAUCT_MAX_BID_ANALYSIS] = React.useState(null);
  const [PREAUCT_MAX_BID_ANALYSIS_D, setPREAUCT_MAX_BID_ANALYSIS_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Pre-Auction Maximum Bid Analysis');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/PREAUCT_Max_Bid_Analysis',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewPREAUCT_MAX_BID_ANALYSIS(clientInfo,"OpenNew");

		navigate('/PREAUCT_Max_Bid_Analysis',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Max_Bid_Analysis_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutPREAUCT_MAX_BID_ANALYSIS(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostPREAUCT_MAX_BID_ANALYSIS(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewPREAUCT_MAX_BID_ANALYSIS(clientInfo,"OpenNew");
		}
		navigate('/PREAUCT_Max_Bid_Analysis',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Max_Bid_Analysis_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Max_Bid_Analysis_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Max_Bid_Analysis_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
		if(Temp_Data2.status!="New"){
			handleDeletePREAUCT_MAX_BID_ANALYSIS(Temp_Data2);
			navigate('/PREAUCT_Max_Bid_Analysis#New',{replace:true});
		} 
		else 
			navigate('/PREAUCT_Max_Bid_Analysis',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Max_Bid_Analysis',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Max_Bid_Analysis',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Max_Bid_Analysis',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/PREAUCT_Max_Bid_Analysis',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!PREAUCT_MAX_BID_ANALYSIS) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_${i}_SECTION`;
	  const headerId = `#PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [PREAUCT_MAX_BID_ANALYSIS]) ;


  
  
  var Ids = [];
  for(var Ele in PREAUCT_MAX_BID_ANALYSIS){
	  for(var Sec in PREAUCT_MAX_BID_ANALYSIS[Ele]){
		if(Sec == "id")
			Ids.push(PREAUCT_MAX_BID_ANALYSIS[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(PREAUCT_MAX_BID_ANALYSIS[Ele]["status"]);
		else if(Array.isArray(PREAUCT_MAX_BID_ANALYSIS[Ele][Sec]))
			  for(var Row in PREAUCT_MAX_BID_ANALYSIS[Ele][Sec])  // Convert to PREAUCT_MAX_BID_ANALYSIS[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in PREAUCT_MAX_BID_ANALYSIS[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["PREAUCT_MAX_BID_ANALYSIS"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewPREAUCT_MAX_BID_ANALYSIS(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_MAX_BID_ANALYSIS`).then((response1) => {
		if(!PREAUCT_MAX_BID_ANALYSIS) 
			setPREAUCT_MAX_BID_ANALYSIS(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_MAX_BID_ANALYSIS_D`).then((response2) => {
			setPREAUCT_MAX_BID_ANALYSIS_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddPREAUCT_MAX_BID_ANALYSIS_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewPREAUCT_MAX_BID_ANALYSIS = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_MAX_BID_ANALYSIS/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setPREAUCT_MAX_BID_ANALYSIS(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataPREAUCT_MAX_BID_ANALYSIS = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_MAX_BID_ANALYSIS/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutPREAUCT_MAX_BID_ANALYSIS = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_MAX_BID_ANALYSIS/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostPREAUCT_MAX_BID_ANALYSIS = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_MAX_BID_ANALYSIS', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeletePREAUCT_MAX_BID_ANALYSIS = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_MAX_BID_ANALYSIS', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["1"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_0"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_0",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["1"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_1"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_1",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["1"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_2"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_2",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["1"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_3"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_3",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["2"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_0"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_0",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["2"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_1"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_1",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["2"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_2"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_2",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["2"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_3"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_3",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["3"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_0"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_0",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["3"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_1"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_1",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["3"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_2"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_2",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["4"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_4_0"]=value;
	Form_Data_onChange("4","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_4_0",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
  }; 
  

    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["4"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_4_1"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("4","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_4_1",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_0"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_0",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_1"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_1",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_2"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_2",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_3"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_3",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_4"]=value;
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_4",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
  }; 
  

    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_5"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_5",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["9"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_0"]=value;
	Form_Data_onChange("9","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_0",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
  }; 
  

    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["9"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_1"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_1",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["9"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_2"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_2",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["9"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_3"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_3",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
	Temp_Data["9"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_4"]=value;
	//handleAddPREAUCT_MAX_BID_ANALYSIS(Temp_Data,App_Data['PREAUCT_MAX_BID_ANALYSIS']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_4",value,Temp_Data);
 	//handleLastDataPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
    setPREAUCT_MAX_BID_ANALYSIS(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!PREAUCT_MAX_BID_ANALYSIS) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedPREAUCT_MAX_BID_ANALYSIS =JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
  updatedPREAUCT_MAX_BID_ANALYSIS[Sec] = [...updatedPREAUCT_MAX_BID_ANALYSIS[Sec], newRow];
  setPREAUCT_MAX_BID_ANALYSIS(updatedPREAUCT_MAX_BID_ANALYSIS);
};

const handleDeleteRow = (sec,index) => {
  const updatedPREAUCT_MAX_BID_ANALYSIS = JSON.parse(JSON.stringify(PREAUCT_MAX_BID_ANALYSIS));
  updatedPREAUCT_MAX_BID_ANALYSIS[sec].splice(index, 1);
  setPREAUCT_MAX_BID_ANALYSIS(updatedPREAUCT_MAX_BID_ANALYSIS);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Pre-Auction Maximum Bid Analysis`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Pre-Auction Max Bid Analysis ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Max Bid Analysis ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_0" type="text" className="form-control" placeholder="PREAUCT Max Bid Analysis ID" value={PREAUCT_MAX_BID_ANALYSIS["1"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_0`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Max Bid Analysis ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Auction Opportunity ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_1" type="text" className="form-control" placeholder="PREAUCT Auction Opportunity ID" value={PREAUCT_MAX_BID_ANALYSIS["1"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_1`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Auction Opportunity ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Estimated As Is Value USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_2" type="text" className="form-control" placeholder="Estimated As Is Value USD" value={PREAUCT_MAX_BID_ANALYSIS["1"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_2`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Estimated As Is Value USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Estimated After Repair Value USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_3" type="text" className="form-control" placeholder="Estimated After Repair Value USD" value={PREAUCT_MAX_BID_ANALYSIS["1"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_3`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Estimated After Repair Value USD`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Estimated Repair Cost USD`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Estimated Repair Cost USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_0" type="text" className="form-control" placeholder="Estimated Repair Cost USD" value={PREAUCT_MAX_BID_ANALYSIS["2"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_0`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Estimated Repair Cost USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Estimated Closing Cost USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_1" type="text" className="form-control" placeholder="Estimated Closing Cost USD" value={PREAUCT_MAX_BID_ANALYSIS["2"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_1`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Estimated Closing Cost USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Estimated Carrying Cost USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_2" type="text" className="form-control" placeholder="Estimated Carrying Cost USD" value={PREAUCT_MAX_BID_ANALYSIS["2"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_2`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Estimated Carrying Cost USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Required Reserve USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_3" type="text" className="form-control" placeholder="Required Reserve USD" value={PREAUCT_MAX_BID_ANALYSIS["2"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_3`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Required Reserve USD`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Target Return Percentage`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Target Return Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_0" type="text" className="form-control" placeholder="Target Return Percentage" value={PREAUCT_MAX_BID_ANALYSIS["3"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_0`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Target Return Percentage`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Recommended Max Bid USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_1" type="text" className="form-control" placeholder="Recommended Max Bid USD" value={PREAUCT_MAX_BID_ANALYSIS["3"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_1`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Recommended Max Bid USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Authorized Max Bid USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_2" type="text" className="form-control" placeholder="Authorized Max Bid USD" value={PREAUCT_MAX_BID_ANALYSIS["3"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_2`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_3_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Authorized Max Bid USD`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Bid Strategy`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Bid Strategy`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_4_0"  value={PREAUCT_MAX_BID_ANALYSIS["4"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_4_0`]} onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_4_0_Change} className="form-control" name="Bid Strategy"  >
						  <option value="Conservative">Conservative</option>
						  <option value="Target Bid">Target Bid</option>
						  <option value="Aggressive">Aggressive</option>
						  <option value="Do Not Bid">Do Not Bid</option>
						  <option value="Manual Strategy">Manual Strategy</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Bid Strategy
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Analysis Report Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_4_1" type="text" className="form-control" placeholder="Analysis Report Link" value={PREAUCT_MAX_BID_ANALYSIS["4"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_4_1`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_4_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_4_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Analysis Report Link`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_0" type="text" className="form-control" placeholder="Submitted By" value={PREAUCT_MAX_BID_ANALYSIS["5"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_0`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_1" type="text" className="form-control" placeholder="Submitted At" value={PREAUCT_MAX_BID_ANALYSIS["5"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_1`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_2" type="text" className="form-control" placeholder="Reviewed By" value={PREAUCT_MAX_BID_ANALYSIS["5"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_2`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_3" type="text" className="form-control" placeholder="Reviewed At" value={PREAUCT_MAX_BID_ANALYSIS["5"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_3`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_4"  value={PREAUCT_MAX_BID_ANALYSIS["5"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_4`]} onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_5" type="text" className="form-control" placeholder="Approval Notes" value={PREAUCT_MAX_BID_ANALYSIS["5"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_5`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_0"  value={PREAUCT_MAX_BID_ANALYSIS["9"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_0`]} onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_1" type="text" className="form-control" placeholder="Created By" value={PREAUCT_MAX_BID_ANALYSIS["9"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_1`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_2" type="text" className="form-control" placeholder="Created At" value={PREAUCT_MAX_BID_ANALYSIS["9"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_2`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_3" type="text" className="form-control" placeholder="Updated By" value={PREAUCT_MAX_BID_ANALYSIS["9"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_3`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_4" type="text" className="form-control" placeholder="Updated At" value={PREAUCT_MAX_BID_ANALYSIS["9"][`PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_4`]} 
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_MAX_BID_ANALYSIS_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default PREAUCT_Max_Bid_Analysis;  